import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

export enum ClientActivation {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE'
}

export interface IClientTerminationReasonsModalEvent {
  visibility: boolean;
  clientActivation?: ClientActivation;
}

@Injectable({
  providedIn: 'root'
})
export class ClientTerminationReasonsModalService {
  private selectedPatientId: BehaviorSubject<number> = new BehaviorSubject<number>(null);
  private clientTerminationReasonsModalEvent = new BehaviorSubject<IClientTerminationReasonsModalEvent>({
    visibility: false
  });

  setSelectedPatientId(id: number): void {
    this.selectedPatientId.next(id);
  }

  getSelectedPatientId(): Observable<number> {
    return this.selectedPatientId.asObservable();
  }

  /**
   * toggleModal takes a boolean status with a default of false
   * and calls next on clientTerminationReasonsModalEvent using that value.
   *
   *
   * @param {boolean} [status=!this.clientTerminationReasonsModalEvent.value]
   * @memberof ClientTerminationReasonsModalService
   */
  toggleModal(currentStatus: boolean = !this.clientTerminationReasonsModalEvent.value.visibility, activationEvent?: ClientActivation): void {
    this.clientTerminationReasonsModalEvent.next({
      visibility: currentStatus,
      clientActivation: activationEvent
    });
  }

  /**
   * subscribeToModalEvents emits the current value of clientTerminationReasonsModalEvent as an Observable
   *
   * @return {Observable<IClientTerminationReasonsModalEvent>}
   * @memberof ClientTerminationReasonsModalService
   */
  subscribeToModalEvents(): Observable<IClientTerminationReasonsModalEvent> {
    return this.clientTerminationReasonsModalEvent.asObservable();
  }
}
